import * as LucideIcons from 'lucide-react'
import { FileText, type LucideProps } from 'lucide-react'
import type { ForwardRefExoticComponent, RefAttributes } from 'react'

type LucideIcon = ForwardRefExoticComponent<LucideProps & RefAttributes<SVGSVGElement>>

function kebabToPascal(name: string): string {
  return name
    .split('-')
    .map((part) => part.charAt(0).toUpperCase() + part.slice(1))
    .join('')
}

export function DynamicIcon({ name, className }: { name: string | null | undefined; className?: string }): JSX.Element {
  if (!name) {
    return <FileText className={className} />
  }

  const pascalName = kebabToPascal(name)
  const icons = LucideIcons as Record<string, unknown>
  const IconComponent = icons[pascalName]

  if (typeof IconComponent !== 'function' && typeof IconComponent !== 'object') {
    return <FileText className={className} />
  }

  const Icon = IconComponent as LucideIcon
  return <Icon className={className} />
}
